import React from 'react';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { useTranslation } from 'react-i18next';

interface LoadingPageProps { className?: string }

const LoadingPage: React.FC<LoadingPageProps> = ({ className = '' }) => {
    const { t } = useTranslation('common');

    return (
        <div
            className={`w-full h-[775px] flex items-center justify-center bg-white rounded-2xl p-4 shadow-sm ${className}`}
        >
            <LoadingSpinner message={`${t("loading")} `} />
        </div>
    );
};

export default LoadingPage;
